import useAmplitudeUserMapping from "@/hooks/useAmplitudeUserMapping";
import useGetUserData from "@/hooks/useGetUserData";
import { captureException } from "@sentry/react";
import { PropsWithChildren, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";

export default function AuthDbUser({ children }: PropsWithChildren) {
  const { data, isLoading, isError, error } = useGetUserData();
  const { mutate: mapAmplitudeUser } = useAmplitudeUserMapping();
  const hasMappedUser = useRef(false);

  useEffect(() => {
    if (data?.id && !hasMappedUser.current) {
      hasMappedUser.current = true;
      mapAmplitudeUser(data.id);
    }
  }, [data, mapAmplitudeUser]);

  if (isError) {
    console.error("Error fetching user data", error);
    captureException(error);
    return <Navigate to={"/finish-registration"} />;
  }

  if (isLoading) {
    return null;
  }

  return <> {children}</>;
}
